import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import BooleanRen from "csi/heading/Boolean";
import declare from "dojo/_base/declare";

const CareAndCompositionBooleanRender = declare(BooleanRen, {
	/**
	 * @override
	 * Show a checkbox, checked if this is an Sales Region Exception node
	 */
	_getValue(ctx: Context, h: Heading) {
		return ctx.getNode().SalesRegionItems.length>0 ? true : false;
	},
});

export = CareAndCompositionBooleanRender;